// extracted by mini-css-extract-plugin
export default {"video-wrapper":"video-wrapper--x4tA9","videoWrapper":"video-wrapper--x4tA9","blink":"blink--kgWJC"};